import React from 'react'
import {createRoot} from 'react-dom/client'
import {DefaultUIContextProvider} from '@colonist/ui'
import {getUIContextValue} from '../GetContextValues.ts'

export interface UIReactComponentView<T> {
    render: (props: T) => void
    unmount: () => void
}

export type UIReactComponentViewOf<C extends React.FunctionComponent<any>> = UIReactComponentView<React.ComponentProps<C>>

export const mountUIReactComponent = <T extends object>(
    containerId: string,
    Component: React.FunctionComponent<T>,
): UIReactComponentView<T> => {
    const container = document.getElementById(containerId)
    if(!container) throw new Error(`Container with id ${containerId} not found`)
    const root = createRoot(container)
    const uiContextValue = getUIContextValue()

    return {
        render: (props: T) => {
            root.render(<DefaultUIContextProvider {...uiContextValue}>
                <Component {...props} />
            </DefaultUIContextProvider>)
        },
        unmount: () => root.unmount(),
    }
}
